(function () {
  var SIZE_LABELS = ['taglia', 'taglie', 'size', 'sizes', 'misura'];

  function norm(v) {
    return String(v == null ? '' : v).trim().toLowerCase();
  }

  function labelText(input) {
    var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    if (!label) return null;
    var span = label.querySelector('span');
    return { label: label, value: norm((span || label).textContent) };
  }

  function apply(picker) {
    var variantsEl = picker.querySelector('script[data-hidden-variants]');
    var sizesEl = picker.querySelector('script[data-hidden-sizes]');
    if (!variantsEl && !sizesEl) return;

    var hidden = [];
    var hiddenSizes = [];
    try {
      if (variantsEl) hidden = JSON.parse(variantsEl.textContent).map(function (opts) { return opts.map(norm); });
      if (sizesEl) hiddenSizes = String(JSON.parse(sizesEl.textContent)).split(',').map(norm).filter(Boolean);
    } catch (e) { return; }

    var fieldsets = picker.querySelectorAll('fieldset.variant-picker__option');
    var groups = [];
    var selected = [];

    fieldsets.forEach(function (fs, idx) {
      var legend = fs.querySelector('legend');
      var name = legend ? norm(legend.textContent.replace(':', '')) : '';
      var items = [];
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var info = labelText(input);
        if (info) items.push({ input: input, label: info.label, value: info.value });
        if (info && input.checked) selected[idx] = info.value;
      });
      groups.push({ isSize: SIZE_LABELS.indexOf(name) !== -1, items: items });
    });

    groups.forEach(function (group, idx) {
      if (!group.isSize) return;

      var visibleItems = [];
      group.items.forEach(function (item) {
        var candidate = selected.slice();
        candidate[idx] = item.value;
        var isHidden = hiddenSizes.indexOf(item.value) !== -1 || hidden.some(function (h) {
          return h.every(function (val, i) { return candidate[i] === undefined || candidate[i] === val; });
        });

        if (isHidden) {
          item.label.style.display = 'none';
          item.input.style.display = 'none';
          item.label.setAttribute('data-hv-hidden', '');
        } else {
          if (item.label.hasAttribute('data-hv-hidden')) {
            item.label.style.display = '';
            item.input.style.display = '';
            item.label.removeAttribute('data-hv-hidden');
          }
          visibleItems.push(item);
        }
      });

      var current = group.items.filter(function (item) { return item.input.checked; })[0];
      if (current && current.label.hasAttribute('data-hv-hidden') && visibleItems.length) {
        var next = visibleItems.filter(function (item) { return !item.input.disabled; })[0] || visibleItems[0];
        next.input.click();
      }
    });
  }

  function run() {
    document.querySelectorAll('variant-picker').forEach(apply);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('change', schedule);
  document.addEventListener('variant:changed', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  run();
})();
